import { Component, OnInit, ViewChild } from '@angular/core';
import { TimetrackSelectors, TimetrackDispatchers } from '../store/services';
import { map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { Korebog } from '@store/models';
import { MileageLogComponent } from './mileage-log.component';

@Component({
    selector: 'app-mileage-log',
    template: `
        <app-mileage-log-ui
            [korebog]="korebog$ | async"
            [ugerapportSager]="ugerapportSager$ | async"
            [ugerapportKunder]="ugerapportKunder$ | async"
            [user]="user$ | async"
            (save)="save($event)"
            (delete)="delete($event)"
        ></app-mileage-log-ui>
    `,
    standalone: false
})
export class MileageLogContainerComponent implements OnInit {

    korebog$: Observable<Korebog[]>;
    ugerapportSager$ = this.timetrackSelector.ugerapportSager$;
    ugerapportKunder$ = this.timetrackSelector.ugerapportKunder$;
    user$ = this.timetrackSelector.user$;

    @ViewChild(MileageLogComponent) mileageLogUi: MileageLogComponent;

    constructor(
        private timetrackSelector: TimetrackSelectors,
        private timetrackDispatch: TimetrackDispatchers
    ) { }

    ngOnInit() {
        const korebogWithKunderAndSager$ = combineLatest(
            this.timetrackSelector.korebog$,
            this.timetrackSelector.ugerapportKunder$,
            this.timetrackSelector.ugerapportSager$
        );
        this.korebog$ = korebogWithKunderAndSager$.pipe(
            map(([kbs, kunder, sager]) => kbs.map(kb => ({
                ...kb,
                label: kunder.find(k => +k.kid === +kb.kid)?.label,
                sagBeskrivelse: sager.find(s => +s.sag === +kb.sag)?.beskrivelse
            })))
        );
    }

    save(korebog: Korebog) {
        if (korebog.id === 0) {
            this.timetrackDispatch.createKorebog(korebog);
        } else {
            this.timetrackDispatch.updateKorebog(korebog);
        }
    }

    delete(id: number) {
        this.timetrackDispatch.deleteKorebog(id);
    }

    pdfMileage() {
        this.mileageLogUi.pdfMileage();
    }

}
